export default __webpack_public_path__ + "static/media/bg-map.f0c5ffe4.png";